import { useT } from "../../contexts/LanguageContext";
import React, { useEffect, useState } from "react";
import { ChartBarIcon, ArrowPathIcon } from "@heroicons/react/24/outline";
import { getMyStats } from "../../api/operator";

const Card = ({ label, value, accent = "blue" }) => {
  const cls = {
    blue: "border-blue-500/30 text-blue-400",
    green: "border-green-500/30 text-green-400",
    amber: "border-amber-500/30 text-amber-400",
  }[accent];
  return (
    <div className={`dark-card border ${cls} p-5 rounded-xl`}>
      <div className="text-text-secondary text-sm mb-1">{label}</div>
      <div className="text-3xl font-bold text-white">{value}</div>
    </div>
  );
};

const StatsPanel = () => {
  const t = useT();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getMyStats();
      setStats(data);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="p-6 max-w-3xl">
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-accent-grad rounded-xl flex items-center justify-center">
            <ChartBarIcon className="w-6 h-6 text-white" />
          </div>
          <h2 className="text-xl font-bold text-white">{t("stats.myStats")}</h2>
        </div>
        <button
          onClick={load}
          disabled={loading}
          className="p-2 rounded-lg border border-gray-700 text-text-secondary"
        >
          <ArrowPathIcon className={`w-5 h-5 ${loading ? "animate-spin" : ""}`} />
        </button>
      </div>
      {error && (
        <div className="p-4 rounded-lg bg-red-500/10 border border-red-500/30 text-red-400 mb-4">
          {error}
        </div>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <Card label={t("stats.open")} value={stats?.open ?? 0} accent="amber" />
        <Card label={t("stats.closed24h")} value={stats?.closed_24h ?? 0} accent="blue" />
        <Card label={t("stats.closed7d")} value={stats?.closed_7d ?? 0} accent="green" />
      </div>
    </div>
  );
};

export default StatsPanel;
